import { VdpFinanceLease } from '../components/vdp/finance-lease.vue';
Vue.component('vdp-finance-lease', VdpFinanceLease);